import { createStore } from "owa-satcheljs";
import type { MailboxInfo } from "owa-client-types";

interface SelectAccountNotificationStore {
    selectedAccountOptions: Set<MailboxInfo>;
}

const initialState: SelectAccountNotificationStore = {
    selectedAccountOptions: new Set<MailboxInfo>(),
};

const selectAccountNotificationStore: () => SelectAccountNotificationStore = createStore<SelectAccountNotificationStore>("selectAccountNotificationStore", initialState);

export default selectAccountNotificationStore;
